// Module
var code = "<template> <require from=\"app/cm/components/summary/case-summary\" as=\"summary\"></require> <compose view-model=\"app/cm/components/summary/case-summary\" model.bind=\"modelData\"></compose> </template> ";
// Exports
module.exports = code;